import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetChangelogResponseDtoSchema = z.object({
  version: z.string(),
  changelog: z.string(),
});

export type GetChangelogResponseDto = z.infer<
  typeof GetChangelogResponseDtoSchema
>;

export const getChangelog = () => {
  return api
    .get('/changelog')
    .then(responseContract(GetChangelogResponseDtoSchema));
};
